import React from 'react'
import { Typography, Accordion, AccordionDetails, AccordionSummary } from '@mui/material'
import { ExpandMore } from '@mui/icons-material'
import AccordionContainer from '../components/AccordionContainer'

const FAQ = () => {
  return (
    <AccordionContainer title='common.faq'>
      <Typography mb={3} align='left'>
        It is normal to have questions, here you will find the answers to the most frequently asked questions by our
        customers.
      </Typography>
      <Accordion>
        <AccordionSummary expandIcon={<ExpandMore />}>CounterSketch First-Steps troubleshooting</AccordionSummary>
        <AccordionDetails>
          <Typography>Windows 10 DPI Scaling</Typography>
          <ul>
            <Typography>
              <li>Right click on the CounterSketch icon on the desktop.</li>
            </Typography>
            <Typography>
              <li>Left click on Properties.</li>
            </Typography>
            <Typography>
              <li>Go to the Compatibility tab.</li>
            </Typography>
            <Typography>
              <li>Click on Change high DPI settings button.</li>
            </Typography>
            <Typography>
              <li>A new window will appear.</li>
            </Typography>
            <Typography>
              <li>Under High DPI scaling override check the box to override the scaling behavior.</li>
            </Typography>
            <Typography>
              <li>Click on the drop down menu underneath and select System.</li>
            </Typography>
            <Typography>
              <li>Apply the same steps above to the Rhino 5 (64-bit) shortcut icon.</li>
            </Typography>
            <Typography>
              <li>Click OK on both windows to save the settings.</li>
            </Typography>
          </ul>
          <Typography>Geforce Driver Update</Typography>
          <ul>
            <Typography>
              <li>
                In the Windows Start Menu, type Device Manager and press enter to bring up the Windows Device Manager.
              </li>
            </Typography>
            <Typography>
              <li>Once it appears, locate and expand the Display Adapters category.</li>
            </Typography>
            <Typography>
              <li>Double click on your GeForce card in the list to bring up its properties.</li>
            </Typography>
            <Typography>
              <li>Click on the Driver tab to see what Driver Date and Driver Version you are using.</li>
            </Typography>
            <Typography>
              <li>
                If your driver is outdated, please download and install the latest from{' '}
                <a href='https://www.nvidia.com/en-us/geforce/drivers/' target='_blank' rel='noopener noreferrer'>
                  GeForce.com/drivers
                </a>
                .
              </li>
            </Typography>
            <Typography>
              <li>If you do need to update, choose the option for Custom Installation.</li>
            </Typography>
            <Typography>
              <li>On the next screen, check the box to perform a clean installation.</li>
            </Typography>
            <Typography>
              <li>Also, in the list of items near the top, uncheck the option for GeForce Experience.</li>
            </Typography>
            <Typography>
              <li>After the installation has completed, please restart the computer.</li>
            </Typography>
          </ul>
        </AccordionDetails>
      </Accordion>
      <Accordion>
        <AccordionSummary expandIcon={<ExpandMore />}>MatrixGold Internet Requirements</AccordionSummary>
        <AccordionDetails>
          <ul>
            <Typography>
              <li>
                If you lose your connection for less than 2 minutes at a time, you will see no interruption. So wifi
                signals that are problematic shouldn&#39;t cause issues.
              </li>
            </Typography>
            <Typography>
              <li>MG Requires an Internet Connection to start and you must be logged into the launcher.</li>
            </Typography>
            <Typography>
              <li>
                At the 2nd minute of loss of connectivity, the application hides the Rhino Window and displays
                &quot;Security Failed&quot; and brings the Launcher Window up.
              </li>
            </Typography>
            <Typography>
              <li>
                At the 5th minute of loss of connectivity, the application begins to close, it will prompt to Save your
                work, and perform an &quot;Unexpected Shutdown Save&quot; into that special project folder. It will then
                close MG.
              </li>
            </Typography>
            <Typography>
              <li>
                If at any time before the 5 minute limit your connection is restored, it will resume normal
                functionality.
              </li>
            </Typography>
          </ul>
          <Typography style={{ fontStyle: 'italic' }}>
            If at any time before the 5 minute limit your connection is restored, it will resume normal functionality.
          </Typography>
          <ul>
            <Typography>
              <li>
                If there is no connection activity for up to eight hours then your session in the Gemvision Launcher
                will time out.
              </li>
            </Typography>
            <Typography>
              <li>
                Upon the next time you come back to the computer you will have the Gemvision Launcher in the forefront.
              </li>
            </Typography>
            <Typography>
              <li>If you try to launch MatrixGold you will get stuck at obtaining license</li>
            </Typography>
            <Typography>
              <li>
                To remedy this sign out of the Gemvision Launcher and then back in. Once you have done so you can use
                MatrixGold as normal.
              </li>
            </Typography>
          </ul>
        </AccordionDetails>
      </Accordion>

      <Accordion>
        <AccordionSummary expandIcon={<ExpandMore />}>Firewall Rules for MatrixGold</AccordionSummary>
        <AccordionDetails>
          <Typography gutterBottom>
            If you have a custom firewall set by your local IT administrator then you will need to make sure you allow
            the following through the firewall:
          </Typography>
          <ul>
            <Typography>
              <li>TCP Port 443 - gemvision.s3.amazonaws.com</li>
            </Typography>

            <Typography>
              <li>TCP Port 443 - gems.gemvision.services</li>
            </Typography>

            <Typography>
              <li>TCP Port 443 - logstash.analytics.rhino3d.com</li>
            </Typography>
          </ul>
        </AccordionDetails>
      </Accordion>
    </AccordionContainer>
  )
}

export default FAQ
